import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { style: {
            width: '800px',
        } }
const _hoisted_2 = { class: "sticky-header" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex py-1"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex py-1"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "doughnut-center-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_TutorialsModules = _resolveComponent("TutorialsModules")!
  const _component_DoughnutChart = _resolveComponent("DoughnutChart")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        "fixed-tabs": "",
        style: {"background-color":"transparent !important","border-radius":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { key: "0" }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode(" Tutoriels ")
            ])),
            _: 1
          }),
          (
                        _ctx.starterComponents === 'Sans starterComponents' ||
                        _ctx.starterComponents === null ||
                        _ctx.localEnv !== 'production'
                    )
            ? (_openBlock(), _createBlock(_component_v_tab, { key: "1" }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode(" Modules ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_tab, { key: "2" }, {
            default: _withCtx(() => _cache[24] || (_cache[24] = [
              _createTextVNode(" Suivi personnel ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", null, [
        (_ctx.activeTab === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                label: "Rechercher",
                outlined: "",
                "hide-details": "",
                density: "compact",
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = ''))
              }, null, 8, ["modelValue"]),
              (_ctx.enableWrite && _ctx.localEnv !== 'production')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "ml-2 mr-0 elevation-0",
                    rounded: "xl",
                    density: "compact",
                    variant: "flat",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.step = 'editionTutorials'))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode(" Ajouter ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select_filled, {
                        modelValue: _ctx.selectedCategories,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                        items: _ctx.allCategories,
                        "item-value": "value",
                        label: "Catégories de tutoriels",
                        multiple: "",
                        "small-chips": "",
                        outlined: "",
                        "hide-details": "",
                        clearable: "",
                        style: {"overflow-x":"auto","flex-wrap":"nowrap"},
                        density: "compact",
                        "item-title": (item) => item.text
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 3)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: item.value,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index === 3)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 'more-items',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.selectedCategories.length - 3) + " autres ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_toggle, {
                        modelValue: _ctx.viewMode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.viewMode) = $event)),
                        rounded: "xl",
                        class: "ml-2 pl-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            value: "doughnut",
                            icon: "$fa-chart-pie"
                          }),
                          _createVNode(_component_v_btn_icon, {
                            value: "bar",
                            icon: "$fa-chart-bar"
                          }),
                          _createVNode(_component_v_btn_icon, {
                            value: "table",
                            icon: "$fa-list-ul"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.activeTab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "tutorials" }, {
                  default: _withCtx(() => [
                    (_ctx.starterComponents)
                      ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTutos, (tuto) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: tuto.id,
                                class: "my-2",
                                onClick: ($event: any) => (_ctx.setSelectedTuto(tuto.id)),
                                lines: "two",
                                border: "",
                                title: tuto.name,
                                subtitle: tuto.description,
                                rounded: "xl"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode("$fa-photo-video")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_trash, _mergeProps({
                                        size: "small",
                                        ref_for: true
                                      }, props, {
                                        onClick: _withModifiers(($event: any) => (_ctx.deleteTutorial(tuto)), ["stop"])
                                      }), null, 16, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Supprimer", -1))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      (!_ctx.isTutorialCompleted(tuto))
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, _mergeProps({
                                            key: 0,
                                            ref_for: true
                                          }, props, {
                                            "model-value": _ctx.calculateProgress(tuto),
                                            size: "24",
                                            width: "3",
                                            color: "primary",
                                            rounded: ""
                                          }), null, 16, ["model-value"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isTutorialCompleted(tuto))
                                        ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                            key: 1,
                                            size: "24",
                                            width: "3",
                                            ref_for: true
                                          }, props), {
                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                              _createTextVNode(" $oss-circle-check ")
                                            ])),
                                            _: 2
                                          }, 1040))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.getTutorialStatus(tuto)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "title", "subtitle"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                          default: _withCtx(() => [
                            (!_ctx.search)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.pathsToDisplay, (path) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: path[_ctx.pathLevel],
                                    class: "my-2",
                                    onClick: ($event: any) => (_ctx.goTo(path[_ctx.pathLevel])),
                                    lines: "two",
                                    border: "",
                                    title: _ctx.formatFolderTitle(path[_ctx.pathLevel]),
                                    rounded: "xl"
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                          _createTextVNode("$fa-folder")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                                          _createTextVNode("$oss-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "title"]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTutos, (tuto) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: tuto.id,
                                class: "my-2",
                                onClick: ($event: any) => (_ctx.setSelectedTuto(tuto.id)),
                                lines: "two",
                                border: "",
                                title: tuto.name,
                                subtitle: tuto.description,
                                rounded: "xl"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createTextVNode("$fa-photo-video")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_trash, _mergeProps({
                                        size: "small",
                                        ref_for: true
                                      }, props, {
                                        onClick: _withModifiers(($event: any) => (_ctx.deleteTutorial(tuto)), ["stop"])
                                      }), null, 16, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[32] || (_cache[32] = _createElementVNode("span", null, "Supprimer", -1))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      (!_ctx.isTutorialCompleted(tuto))
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, _mergeProps({
                                            key: 0,
                                            ref_for: true
                                          }, props, {
                                            "model-value": _ctx.calculateProgress(tuto),
                                            color: "primary",
                                            size: "24",
                                            width: "3",
                                            rounded: ""
                                          }), null, 16, ["model-value"]))
                                        : (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                            key: 1,
                                            size: "24",
                                            width: "3",
                                            ref_for: true
                                          }, props, { color: "primary" }), {
                                            default: _withCtx(() => _cache[33] || (_cache[33] = [
                                              _createTextVNode(" $oss-circle-check ")
                                            ])),
                                            _: 2
                                          }, 1040))
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.getTutorialStatus(tuto)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "title", "subtitle"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "displayTutorial" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", { innerHTML: _ctx.previewHTML }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "editionTutorials" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              innerHTML: _ctx.previewHTML,
                              style: {
                                        width: '500px',
                                    }
                            }, null, 8, _hoisted_6)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "pt-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.tutorialEdition.name,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tutorialEdition.name) = $event)),
                              label: "Nom",
                              outlined: "",
                              class: "pr-1",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.tutorialEdition.status,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tutorialEdition.status) = $event)),
                              label: "statut",
                              class: "pr-1",
                              items: _ctx.status,
                              "item-value": "value",
                              "item-title": (item) => item.text,
                              density: "compact",
                              outlined: ""
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.tutorialEdition.estimatedDuration,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tutorialEdition.estimatedDuration) = $event)),
                              modelModifiers: { number: true },
                              label: "Durée estimée (en secondes)",
                              outlined: "",
                              class: "pr-1",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.tutorialEdition.stepCount,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tutorialEdition.stepCount) = $event)),
                              modelModifiers: { number: true },
                              label: "Nombre d'étapes",
                              outlined: "",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.tutorialEdition.description,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tutorialEdition.description) = $event)),
                              label: "Description",
                              outlined: "",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_textarea_filled, {
                              modelValue: _ctx.tutorialEdition.embedCode,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tutorialEdition.embedCode) = $event)),
                              label: "Embed code",
                              placeholder: `<div>\n    ...\n</div>`,
                              outlined: "",
                              density: "compact",
                              "hide-details": "",
                              onChange: _ctx.onEmbedCodeChange
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.tutorialEdition.url,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tutorialEdition.url) = $event)),
                              label: "Url",
                              outlined: "",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_ctx.tutorialEdition.id && _ctx.enableWrite)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field_filled, {
                                  modelValue: _ctx.tutorialEdition.key,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tutorialEdition.key) = $event)),
                                  label: "Key",
                                  outlined: "",
                                  density: "compact",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_combobox_filled, {
                              modelValue: _ctx.tutorialEdition.starterComponents,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tutorialEdition.starterComponents) = $event)),
                              items: _ctx.referencedComponents,
                              label: "Nom des composants",
                              density: "compact",
                              multiple: "",
                              "persistent-hint": "",
                              outlined: "",
                              chips: "",
                              clearable: ""
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_combobox_filled, {
                              modelValue: _ctx.tutorialEdition.path,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tutorialEdition.path) = $event)),
                              items: _ctx.referencedPaths,
                              label: "Chemin d'accès",
                              density: "compact",
                              multiple: "",
                              hint: "Utiliser '/' pour séparer les menus",
                              "persistent-hint": "",
                              outlined: "",
                              chips: "",
                              clearable: ""
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_combobox_filled, {
                              modelValue: _ctx.tutorialEdition.tags,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tutorialEdition.tags) = $event)),
                              label: "Étiquettes",
                              density: "compact",
                              multiple: "",
                              outlined: "",
                              chips: "",
                              "hide-details": "",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_combobox_filled, {
                              modelValue: _ctx.tutorialEdition.authorizedFor,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tutorialEdition.authorizedFor) = $event)),
                              label: "Autorisations",
                              items: _ctx.authorizationList,
                              density: "compact",
                              multiple: "",
                              outlined: "",
                              chips: "",
                              "hide-details": "",
                              clearable: ""
                            }, {
                              item: _withCtx(({ item }) => [
                                _createVNode(_component_v_checkbox, {
                                  label: _ctx.formatText(item),
                                  "model-value": 
                                                _ctx.tutorialEdition.authorizedFor.includes(
                                                    _ctx.normalizeItem(item),
                                                )
                                            ,
                                  color: "primary",
                                  density: "compact",
                                  size: "small",
                                  "hide-details": "",
                                  "onUpdate:modelValue": 
                                                (checked) => {
                                                    const rawValue = _ctx.normalizeItem(item);
                                                    if (checked) {
                                                        if (
                                                            !_ctx.tutorialEdition.authorizedFor.includes(
                                                                rawValue,
                                                            )
                                                        ) {
                                                            _ctx.tutorialEdition.authorizedFor.push(
                                                                rawValue,
                                                            );
                                                        }
                                                    } else {
                                                        const index =
                                                            _ctx.tutorialEdition.authorizedFor.indexOf(
                                                                rawValue,
                                                            );
                                                        if (index > -1) {
                                                            _ctx.tutorialEdition.authorizedFor.splice(
                                                                index,
                                                                1,
                                                            );
                                                        }
                                                    }
                                                }
                                            
                                }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                              ]),
                              selection: _withCtx(({ item }) => [
                                _createVNode(_component_v_chip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatText(item)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            (
                                        _ctx.tutorialEdition.id &&
                                        _ctx.enableWrite &&
                                        _ctx.localEnv !== 'production'
                                    )
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  class: "ml-2 mr-0 elevation-0",
                                  color: "primary",
                                  dark: "",
                                  rounded: "",
                                  density: "compact",
                                  outlined: "",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.deleteTutorial(_ctx.tutorialEdition)))
                                }, {
                                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                                    _createTextVNode(" Supprimer ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_btn, {
                              class: "ml-2 mr-0 elevation-0",
                              color: "primary",
                              rounded: "",
                              density: "compact",
                              disabled: _ctx.disabledBtn,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sendTutorialEdition(_ctx.tutorialEdition)))
                            }, {
                              default: _withCtx(() => _cache[35] || (_cache[35] = [
                                _createTextVNode(" Valider ")
                              ])),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: 1 }, {
          default: _withCtx(() => [
            (_ctx.activeTab === 1)
              ? (_openBlock(), _createBlock(_component_TutorialsModules, {
                  key: 0,
                  ref: "tutorialsModules"
                }, null, 512))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                (_ctx.filteredTutorialsForCurrentUser.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        (_ctx.viewMode === 'doughnut' && !_ctx.starterComponents)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                (_ctx.chartDataDoughnut)
                                  ? (_openBlock(), _createBlock(_component_DoughnutChart, {
                                      key: 0,
                                      data: _ctx.chartDataDoughnut,
                                      options: _ctx.doughnutChartOptions,
                                      height: _ctx.$vuetify.display.mobile ? 200 : 350
                                    }, null, 8, ["data", "options", "height"]))
                                  : _createCommentVNode("", true),
                                (_ctx.chartDataDoughnut)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.globalProgress) + "% ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : (_ctx.viewMode === 'bar')
                            ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                default: _withCtx(() => [
                                  (_ctx.horizontalBarChartData)
                                    ? (_openBlock(), _createBlock(_component_BarChart, {
                                        key: 0,
                                        data: _ctx.horizontalBarChartData,
                                        options: _ctx.horizontalBarChartOptions,
                                        height: 300
                                      }, null, 8, ["data", "options"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_ctx.viewMode === 'table')
                              ? (_openBlock(), _createBlock(_component_v_col, { key: 2 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                      headers: _ctx.tableHeaders,
                                      items: _ctx.filteredTutorialsForCurrentUser,
                                      "item-key": "learningObjectId",
                                      class: "elevation-1 table"
                                    }, {
                                      "item.progress": _withCtx(({ item }) => [
                                        (!_ctx.isTutorialCompleted(item))
                                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                              key: 0,
                                              "model-value": _ctx.calculateProgress(item),
                                              color: "primary",
                                              size: "24",
                                              width: "3"
                                            }, null, 8, ["model-value"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.isTutorialCompleted(item))
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "24",
                                              width: "3",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => _cache[36] || (_cache[36] = [
                                                _createTextVNode(" $oss-circle-check ")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createElementVNode("div", { class: "text-center" }, [
                              _createElementVNode("p", null, "Veuillez sélectionner au moins une catégorie.")
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}